<template>
  <div>
    <div
      v-for="user in users"
      :key="user.id"
    >
      <v-avatar size="32" class="mr-2" color="secondary">
        <v-img v-if="user.image" :src="user.image" />
        <v-icon v-else dark>
          mdi-account-circle
        </v-icon>
      </v-avatar>
      {{ user.displayName }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'UserList',
  props: {
    users: {
      type: Array,
      required: true
    }
  }
}
</script>
